import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Nav from "../../atoms/Nav"
import CardsContainer from "../../atoms/CardsContainer"
import UserCard from "../../molecules/UserCard"
import DoctorDrawer from "../../molecules/DoctorDrawer"
import RolesDrawer from "../../molecules/RolesDrawer"

const OrgDoctors = ({
  doctors,
  orgData,
  onUserCreated,
  orgName,
  deleteUser,
  isRemovingUser,
  country,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [openDrawerCreate, setOpenDrawerCreate] = useState(false)
  const [openDrawerRoles, setOpenDrawerRoles] = useState(false)
  const [userEmail, setUserEmail] = useState("")
  const handleSearchChange = (ty) => {
    setSearchValue(ty.target.value)
  }

  const handleAddOrganization = () => {
    if (openDrawerCreate) {
      // setLoadingOrgs(true)
      onUserCreated()
    }
    setOpenDrawerCreate(!openDrawerCreate)
  }

  const handleAssignRoles = () => {
    if (openDrawerRoles) {
      setUserEmail("")
    }
    setOpenDrawerRoles(!openDrawerRoles)
  }

  const handleFetchUpdatedData = () => {
    onUserCreated()
  }

  return (
    <>
      <Nav
        titleKey="orgs_doctors"
        onSearchChange={handleSearchChange}
        onFilter={null}
        onAddClick={handleAddOrganization}
        searchValue={searchValue}
        addText="create_new"
      />
      <Container>
        <CardsContainer
          isEmpty={doctors.length === 0}
          emptyMessage="Aun no tienes médicos dentro de la organización"
          fullHeight
        >
          {doctors
            .filter((u) => {
              const data = u.data()
              if (searchValue) {
                return (
                  data.displayName &&
                  data.displayName
                    .toLowerCase()
                    .includes(searchValue.toLowerCase())
                )
              }
              return true
            })
            .map((usr) => {
              const data = usr.data()
              const doctorData = {
                ...data,
                id: usr.id,
                email: data.email,
                userEmail: data.email,
              }
              return (
                <UserCard
                  key={usr.id}
                  user={doctorData}
                  orgData={orgData}
                  deleteUser={deleteUser}
                  isRemovingUser={isRemovingUser}
                  setUserEmail={setUserEmail}
                  setOpenDrawerRoles={setOpenDrawerRoles}
                  fetchUpdatedData={handleFetchUpdatedData}
                  isDoctor
                  isFromOrgView
                />
              )
            })}
        </CardsContainer>
      </Container>
      <DoctorDrawer
        open={openDrawerCreate}
        closeDrawer={handleAddOrganization}
        orgId={orgData.uid}
        orgName={orgName}
        country={country}
      />
      <RolesDrawer
        open={openDrawerRoles}
        closeDrawer={handleAssignRoles}
        userEmail={userEmail}
      />
    </>
  )
}

export const Container = styled.div`
  height: calc(100% - 150px);
`

OrgDoctors.defaultProps = {
  doctors: [],
  deleteUser: false,
  isRemovingUser: () => {},
}

OrgDoctors.propTypes = {
  doctors: PropTypes.arrayOf(PropTypes.shape()),
  orgData: PropTypes.shape().isRequired,
  orgName: PropTypes.string.isRequired,
  onUserCreated: PropTypes.func.isRequired,
  deleteUser: PropTypes.func,
  isRemovingUser: PropTypes.bool,
  country: PropTypes.string.isRequired,
}

export default OrgDoctors
